import Vue from 'vue'
import VueCurrencyInput from 'vue-currency-input'

const pluginOptions = {
  /* see config reference */
  globalOptions: { currency: null,locale:"de-DE", precision:2,allowNegative: true,distractionFree:false ,autoDecimalMode:true}
}
Vue.use(VueCurrencyInput, pluginOptions)
